import { render, staticRenderFns } from "./UserUsageProtocol.vue?vue&type=template&id=0aed659a&scoped=true&"
import script from "./UserUsageProtocol.vue?vue&type=script&lang=js&"
export * from "./UserUsageProtocol.vue?vue&type=script&lang=js&"
import style0 from "./UserUsageProtocol.vue?vue&type=style&index=0&id=0aed659a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aed659a",
  null
  
)

export default component.exports